import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=0c90e375&scoped=true&"
import script from "./AssetDetails.vue?vue&type=script&lang=ts&"
export * from "./AssetDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AssetDetails.vue?vue&type=style&index=0&id=0c90e375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c90e375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VExpansionPanels,VRow})
